module.exports = __webpack_public_path__ + "static/img/2.8894ac6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/2.png
// module id = BWeT
// module chunks = 0